export default function CombineDesignsIcon() {
  return (
    <svg viewBox="0 0 512 512" xmlns="https://www.w3.org/2000/svg">
      <path d="m464 440c-101.458 0-184-82.542-184-184v-150.058l63.029 63.029a24 24 0 0 0 33.942-33.941l-104-104a24 24 0 0 0 -33.942 0l-104 104a24 24 0 0 0 33.942 33.941l63.029-63.029v150.058c0 101.458-82.542 184-184 184a24 24 0 0 0 0 48 230.481 230.481 0 0 0 164.049-67.951 232.406 232.406 0 0 0 43.951-61.049 232.572 232.572 0 0 0 208 129 24 24 0 0 0 0-48z" />
    </svg>
  );
}
